module.exports = __webpack_public_path__ + "static/media/cvs_logo.2c58f7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cvs_logo.png
// module id = 1723
// module chunks = 0